import React from "react";

export function Stamp({
    children,
    rotation = -6,
    size = "md",
    color = "danger",
    className = "",
    ...props
}) {
    const sizeClass =
        size === "sm" ? "stamp-sm" : size === "lg" ? "stamp-lg" : "stamp-md";
    const colorStyle =
        color === "warning"
            ? { color: "var(--warning)", borderColor: "var(--warning)" }
            : color === "paper"
              ? { color: "var(--paper-2)", borderColor: "var(--paper-2)" }
              : {};
    return (
        <span
            className={`stamp ${sizeClass} ${className}`}
            style={{
                transform: `rotate(${rotation}deg)`,
                ["--rot"]: `${rotation}deg`,
                ...colorStyle,
            }}
            {...props}
        >
            {children}
        </span>
    );
}

export function StampDrop({ children, rotation = -6, ...props }) {
    return (
        <Stamp
            rotation={rotation}
            className={`stamp-drop ${props.className || ""}`}
            {...props}
        >
            {children}
        </Stamp>
    );
}

export default Stamp;
